<template>
    <v-app>
        <v-app-bar app :color="appColors.primary1" dark clipped-left v-if="isLoggedIn">

            <v-app-bar-nav-icon @click.stop="navigationVisible = !navigationVisible" v-if="$vuetify.breakpoint.mdAndDown"></v-app-bar-nav-icon>
            <div class="d-none d-sm-flex align-center" @click="() => { $router.push({name: 'home'}).catch(() => {})}" style="cursor: pointer;">
                <v-img alt="stiftelsen" class="shrink mr-2" contain src="./assets/logo-white.png" transition="scale-transition" width="175" />
            </div>

            <v-spacer></v-spacer>

            <v-select ref="companyselect" @change="selectCompany" :value="$store.getters.company" :items="$store.getters.companies" item-text="name" return-object placeholder="velg selskap" hide-details prepend-inner-icon="mdi-home-city" style="max-width: 350px;">
                <template v-slot:prepend-item>
                    <v-list-item>
                        <v-list-item-content>
                            <v-list-item-title>
                                <v-btn @click="$router.push('relateusertocompany'); $refs.companyselect.isMenuActive = false;" text width="100%">
                                    <v-icon left>mdi-home-city</v-icon>
                                    Legge til bruker i selskapet
                                </v-btn>
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-divider class="mt-2"></v-divider>
                </template>
            </v-select>

            <v-divider inset vertical class="ml-2"></v-divider>

            <v-tooltip bottom v-if="isLoggedIn">
                <template v-slot:activator="{ on }">
                    <v-btn @click="logout" href="" target="_blank" text v-on="on">
                        <v-icon v-if="user.role === 0" class="mr-2">mdi-account</v-icon>
                        <v-icon v-else-if="user.role === 10" class="mr-2">mdi-account-star</v-icon>
                        <v-icon v-else-if="user.role === 100" class="mr-2">mdi-account-tie</v-icon>
                        <v-icon v-else-if="user.role === 1000" class="mr-2">mdi-account-group</v-icon>
                        <span class="mr-2">{{user.firstname}} {{user.lastname}}</span>
                        <v-icon>mdi-logout</v-icon>
                    </v-btn>
                </template>
                <span>logg ut</span>
            </v-tooltip>
        </v-app-bar>

        <!-- :permanent="$vuetify.breakpoint.mdAndUp" -->
        <v-navigation-drawer app v-if="isLoggedIn" v-model="navigationVisible" :permanent="$vuetify.breakpoint.mdAndUp" :mini-variant="false" clipped>
            <v-treeview :active.sync="activeItems" :items="navigationItemsFiltered" item-key="title" activatable hoverable open-on-click return-object>
                <template v-slot:prepend="{item}">
                    <v-icon>{{item.icon}}</v-icon>
                </template>
                <template v-slot:label="{item}">
                    <span>{{item.title}}</span>
                </template>
            </v-treeview>
            <!-- <v-list>
                <v-list-item v-for="navItem in navigationItems" :key="navItem.title" link @click="$router.push(navItem.location)">
                    <v-list-item-icon>
                        <v-icon>{{ navItem.icon }}</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>{{navItem.title}}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list> -->
        </v-navigation-drawer>

        <v-content>
            <router-view></router-view>
        </v-content>

        <v-dialog v-if="isLoggedIn && mustSelectCompany" v-model="mustSelectCompany" persistent max-width="550px">
            <v-card>
                <v-card-title class="white--text" :style="{background: appColors.primary1}">
                    Velg selskap:
                </v-card-title>
                <v-card-text>
                    <v-data-table @click:row="selectCompanyLogin" v-model="companySelection.selected" :items="$store.getters.companies" :headers="companySelection.headers" item-key="registrationNumber" selectable-key="registrationNumber" show-select single-select :mobile-breakpoint=0 hide-default-footer disable-pagination></v-data-table>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="selectCompanyByOkButton" :disabled="companySelection.selected.length == 0" :color="appColors.primary1" class="white--text">OK</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-snackbar v-model="$store.getters.snackbar.show" :color="$store.getters.snackbar.color" :timeout="$store.getters.snackbar.timeout" bottom right>
            {{$store.getters.snackbar.text}}
        </v-snackbar>
    </v-app>
</template>

<script>
// import * as axios from "axios";
// import * as jwt from "jsonwebtoken";
import { Role } from "./utilities/enums";
import { mapState } from "vuex";
import { colors as appColors } from "./utilities/colors";

export default {
    name: "App",

    data: () => ({
        appColors,
        navigationVisible: false,
        navigationItems: [
            {
                title: "Startside",
                icon: "mdi-home",
                path: "/home"
                // children: [
                //     {
                //         title: "Brukere",
                //         icon: "mdi-account-multiple",
                //         location: "users"
                //     }
                // ]
            },
            {
                title: "selskap",
                company: true,
                icon: "mdi-home-city",
                children: [
                    {
                        title: "Ny søknad",
                        icon: "mdi-file-edit",
                        path: "/application/0",
                        roles: [Role.USER, Role.MAINUSER, Role.SUPERUSER],
                    },
                    {
                        title: "Oversikt søknader",
                        icon: "mdi-file-multiple",
                        path: "/applications",
                        roles: [Role.USER, Role.MAINUSER, Role.SUPERUSER],
                    },
                    {
                        title: "Brukere",
                        icon: "mdi-account-multiple",
                        path: "/users",
                        roles: [Role.USER, Role.MAINUSER, Role.SUPERUSER],
                    }
                ]
            },
            {
                title: "Admin",
                icon: "mdi-cog",
                roles: [Role.REVISOR, Role.SUPERUSER],
                children: [
                    {
                        title: "Søknader",
                        icon: "mdi-file-multiple",
                        path: "/applicationadmin",
                        roles: [Role.SUPERUSER]
                    },
                    {
                        title: "Selskaper",
                        icon: "mdi-home-city",
                        path: "/companiesadmin",
                        roles: [Role.SUPERUSER]
                    },
                    {
                        title: "Innstillinger",
                        icon: "mdi-cog-outline",
                        path: "/applicationsettingadmin",
                        roles: [Role.SUPERUSER]
                    },
                    {
                        title: "Kommunikasjon",
                        icon: "mdi-at",
                        path: "/communicationadmin",
                        roles: [Role.SUPERUSER]
                    },
                    {
                        title: "E-post",
                        icon: "mdi-email",
                        path: "/emailadmin",
                        roles: [Role.SUPERUSER]
                    },
                    {
                        title: "Eksport",
                        icon: "mdi-export-variant",
                        path: "/exportadmin",
                        roles: [Role.REVISOR, Role.SUPERUSER]
                    },
                    {
                        title: "Rapportering",
                        icon: "mdi-format-list-numbered",
                        path: "/reportsAdmin",
                        roles: [Role.REVISOR, Role.SUPERUSER]
                    }
                ]
            }
        ],
        companySelection: {
            headers: [
                { text: "Navn", value: "name" },
                { text: "Org.nummer", value: "registrationNumber" }
            ],
            selected: []
        },
        activeItems: []
    }),
    computed: {
        ...mapState(["company","user"]),
        isLoggedIn() {
            return this.user.id > 0;
        },
        mustSelectCompany() {
            let _mustSelectCompany = (!this.$store.getters.company || !this.$store.getters.company.id) && this.isLoggedIn;

            // console.log("mustSelectCompany => ", _mustSelectCompany);

            if (_mustSelectCompany) {
                window.addEventListener("keyup", this.selectCompanyByEnter);
            } else {
                window.removeEventListener("keyup", this.selectCompanyByEnter);
            }

            return _mustSelectCompany && this.isLoggedIn && this.$store.getters.companies && this.$store.getters.companies.length > 0;
        },
        navigationItemsFiltered() {
            let filterRecursion = items => {
                let filteredItems = items.filter(i => {
                    if ("roles" in i) {
                        return i.roles.some(r => r === this.user.role);
                    }

                    return true;
                });

                filteredItems = filteredItems.map(fi => {
                    return Object.assign({}, fi);
                });

                filteredItems.forEach(i => {
                    if ("children" in i && i.children.length > 0) {
                        i.children = filterRecursion(i.children);
                    }
                });

                return filteredItems;
            };

            return filterRecursion(this.navigationItems);
        }
    },
    methods: {
        logout() {
            this.$store.dispatch("logout");
            this.$router.push({ name: "login" });
        },
        selectCompanyLogin(company) {
            this.$set(this.companySelection.selected, 0, company);
        },
        selectCompanyByEnter(keyEvent) {
            if (!this.companySelection.selected[0]) return;

            if (keyEvent.keyCode !== 13) {
                return;
            }

            this.selectCompany(this.companySelection.selected[0]);
        },
        selectCompanyByOkButton() {
            this.selectCompany(this.companySelection.selected[0]);
        },
        async selectCompany(company) {
            if (!company) {
                return;
            }

            await this.$store.dispatch("selectCompany", company);
            this.companySelection.selected = [];
            await this.$store.dispatch("fetchUsersForCurrentCompany");
        },
        searchForNavigationItem(property, value) {
            
            for (let index = 0; index < this.navigationItems.length; index++) {
                
                const navItem = this.navigationItems[index];
                let result = this.seachForNavigationItemTree(navItem, property, value);
                if (result) return result;
            }
            return null;
        },
        seachForNavigationItemTree(navItem, property, value) {
            
            if (navItem[property] == value) {
                return navItem;
            } else if (navItem.children) {
                for (let childIndex = 0; childIndex < navItem.children.length; childIndex++) {
                    const childNavItem = navItem.children[childIndex];
                    let result = this.seachForNavigationItemTree(childNavItem, property, value);
                    if (result) return result;
                }
            }
            return null;
        }
    },
    watch: {
        mustSelectCompany(val) {
            if (this.isLoggedIn && val) {
                let companyLocalStorage = JSON.parse(localStorage.getItem("company"));
                if (companyLocalStorage && this.$store.getters.companies.some(c => c.id == companyLocalStorage.id)) {
                    this.companySelection.selected[0] = this.$store.getters.companies.find(c => c.id == companyLocalStorage.id); //
                }
            }
        },
        company: {
            handler: function(val) {
                
                let navItem = this.searchForNavigationItem("company", true);
                

                if (navItem && val) {
                    // navItem.title = val.name;
                    this.$set(navItem, "title", val.name);
                }
            }
        },
        activeItems: {
            handler: function(newVals, oldVals) {
                let to = newVals[0]?.title;
                let from = oldVals[0]?.title;

                // console.log(`activeItems -> from = ${from} ---> to = ${to}`);

                if (from && !to) {
                    // navigating to undefined. This happens when the same navigationItem has been clicked.
                    // reinstate the previous value as the selected value
                    // this.activeItems[0] = this.navigationItems.find(n => n.title === from);
                    this.activeItems[0] = oldVals[0];
                }

                if ((!from && to) || (from !== to && to)) {
                    if (this.$router.currentRoute.path != newVals[0].path) {
                        // navigate
                        this.$router.push({
                            path: newVals[0].path
                        });
                    }
                }
            }
        },
        "$route.path": {
            handler: function(newVal) {
                // console.log(`$route.path -> from = ${oldVal} ---> to = ${newVal}`);

                // let activeItem = this.navigationItems.find(n => n.path === newVal);
                
                let activeItem = this.searchForNavigationItem("path", newVal);
                
                // console.log(`$route stuff => search for navigation item => ${activeItem}`);

                if (!activeItem) {
                    this.activeItems.splice(0);
                } else {
                    if (this.activeItems[0] !== activeItem) {
                        this.activeItems.splice(0);
                        this.activeItems.push(activeItem);
                    }
                }
            }
        }
    },
    beforeMount() {
        if (!this.isLoggedIn) {
            if (this.$router.currentRoute.name === "passwordreset") {
                // this.$router.push({path: "/passwordreset", params: this.$router.currentRoute.params });
                return;
            }

            if (this.$router.currentRoute.name !== "login") {
                this.$router.push({ name: "login" });
            }
        }

        // if (localStorage.getItem("company")) {
        //     try {
        //         let company = JSON.parse(localStorage.getItem("company"));
        //         this.companySelection.selected = [company];
        //     } catch {
        //         delete localStorage.removeItem("company");
        //     }
        // }
    },
    mounted() {}
};
</script>
